export class RestoreRdsInstanceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroups",
            "baseName": "securityGroups",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "subnetGroup",
            "baseName": "subnetGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "databaseFilter",
            "baseName": "databaseFilter",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRdsInstanceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
